import * as Yup from 'yup';
import PageHeader from 'src/components/organisms/PageHeader';
import Footer from 'src/components/molecules/footer/Footer';
import ContentCardsContainer, { CardTab, CardType, ContentCard, HeaderTabs } from 'src/components/organisms/ContentCard';
import { Formik } from 'formik';
import SaveIcon from '@mui/icons-material/Save';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import OutboxIcon from '@mui/icons-material/Outbox';
import { FormContainerMolecule } from 'src/components/molecules/formik/FormContainerMolecule';
import { FormField } from 'src/components/molecules/formik/FormField';
import CustomButton from 'src/components/atoms/buttons/CustomButton';
import useSubmit from 'src/hooks/forms/useSubmit';
import { buildSupplierRequest } from
    'src/utils/submit/submitRequests';
import FormHelper from 'src/utils/formHelper';
import { CustomDataGrid } from 'src/components/organisms/CustomDataGrid';
import { useState } from 'react';
import { useReturnOrderOptions } from 'src/hooks/forms/useOptions';
import { usePackingStationsRowsTable, useReceivingStationsRowsTable, useWarehouseLocationsTable } from 'src/hooks/table/configs/useWarehousesTable';
import { useWarehouseProductLocationsTable } from 'src/hooks/table/configs/useProductLocationsTable';
import { useWarehouseForm } from 'src/hooks/forms/useForms';
import { Grid, Tooltip } from '@mui/material';
import { useActiveWarehouse } from 'src/components/atoms/WarehouseSelector';
import DetailPanelContainer from 'src/components/organisms/tables/DetailPanelContainer';
import { useDispatchOrderRowsTable, useDispatchOrdersTable } from 'src/hooks/table/configs/useDispatchOrdersTable';

const scheme = Yup.object().shape({
});

const defaultInitialValues = {
};

const EditWarehouse = () => {
    const [editId, PageName, currentSubmitFunction, , isEditPage] = FormHelper.getEditPageConfig("Warehouse", buildSupplierRequest, buildSupplierRequest);
    const { warehouseId: selectedWarehouseId, selectWarehouse: setActiveWarehouse } = useActiveWarehouse();
    const warehouseId = isEditPage && editId != null && String(editId).trim() !== '' ? editId : null;
    const isSelectedWarehouse = warehouseId != null && selectedWarehouseId != null && String(warehouseId) === String(selectedWarehouseId);
    const selectWarehouse = () => { if (warehouseId != null && !isSelectedWarehouse) setActiveWarehouse(warehouseId); };
    const selectionTooltip = warehouseId == null ? 'Save the warehouse and open its edit page before selecting it.' : isSelectedWarehouse ? 'This is your active warehouse for all warehouse pages.' : 'Make this your active warehouse for all warehouse pages.';
    const dispatchStationTooltip = isSelectedWarehouse ? 'Open the dispatch station for this warehouse.' : warehouseId == null ? 'Save the warehouse and select it before opening the dispatch station.' : 'Select this warehouse first to open the dispatch station.';
    const initialValues = useWarehouseForm(editId, defaultInitialValues)
    const [returnUnitOptions, returnReasonOptions] = useReturnOrderOptions();
    const [packingstationColumns, packingstationTableSettings] = usePackingStationsRowsTable(initialValues)
    const [locationsColumns, locationsTableSettings] = useWarehouseLocationsTable(editId)
    const [dipatchOrderColumns, dispatchOrderTableSettings] = useDispatchOrdersTable(editId)
    //const [productsColumns, productsTableSettings] = useWarehouseStocksTable(editId)
    const [receivingstationColumns, receivingstationTableSettings] = useReceivingStationsRowsTable(initialValues)
    const [result, submit] = useSubmit(currentSubmitFunction);
    const tabs: CardTab[] = [

        ...(isEditPage ? [{ value: 'Product Locations', label: 'Product Locations' }] : []),
        // { value: 'Products', label: 'Products' },
        { value: 'Locations', label: 'Locations' },
        { value: 'Dispatch Orders', label: 'Dispatch Orders' },
        { value: 'Address', label: 'Address' },
        { value: 'Receiving Stations', label: 'Receiving Stations' },
        { value: 'Packing Stations', label: 'Packing Stations' },
    ]
    const [currentTab, setCurrentTab] = useState<string>(isEditPage ? 'Product Locations' : 'Locations');
    return (
        <>
            <Formik
                initialValues={initialValues}
                validateOnBlur={true} 
                validateOnChange={false}
                validationSchema={scheme}
                onSubmit={submit}
                enableReinitialize
            >
                {(props): JSX.Element => (
                    <div>
                        <PageHeader  {...{
                            title: isEditPage ? ("Edit Warehouse" + (props?.values?.WarehouseName ? ` - ${props?.values?.WarehouseName}` : "")) : "Create Warehouse" ,
                            // initialValues: initialValues,
                            subTitle: "Create and edit Warehouse",
                            components: [
                                { component: <CustomButton isSubmitting={props.isSubmitting} onClick={props.handleSubmit} title="Save" icon={<SaveIcon />} /> },
                                { component: <Tooltip title={selectionTooltip}><span style={{ display: 'inline-flex' }}><CustomButton title={isSelectedWarehouse ? 'Selected Warehouse' : 'Select Warehouse'} variant={isSelectedWarehouse ? 'contained' : 'outlined'} icon={isSelectedWarehouse ? <CheckCircleOutlineIcon /> : <RadioButtonUncheckedIcon />} disabled={warehouseId == null} onClick={selectWarehouse} /></span></Tooltip> },
                                { component: <Tooltip title={dispatchStationTooltip}><span style={{ display: 'inline-flex' }} tabIndex={isSelectedWarehouse ? -1 : 0} aria-label={dispatchStationTooltip}><CustomButton title="Dispatch Station" icon={<OutboxIcon />} disabled={!isSelectedWarehouse} actionUrl={isSelectedWarehouse ? '/warehouse/dispatch-orders/create' : undefined} /></span></Tooltip> },
                                { isInGroupedMenu: true, component: <CustomButton variant="text" title="New Sales Order" icon={<AddTwoToneIcon />} actionUrl="/orders/orders/create" /> },
                            ],
                            alertData: { dataArray: (result ?? false) ? [result] : null }
                        }} />
                        <ContentCardsContainer >
                            <ContentCard {...{ cardId: "Base Info", md: 6 }}>
                                <FormContainerMolecule formikProps={props}>
                                    <FormField fieldProps={{ name: "WarehouseName", label: "Warehouse Name", md: 12 }} formikProps={props}></FormField>
                                    {/* <FormField fieldProps={{ name: "WarehouseId", disabled: true, label: "WarehouseId", md: 4.8 }} formikProps={props}></FormField> */}
                                    <FormField fieldProps={{ name: "OrganizationName", label: "Organization Name", md: 5.8 }} formikProps={props}></FormField>
                                    <FormField fieldProps={{ name: "Address_Street", label: "Address", md: 5.8 }} formikProps={props}></FormField>
                                    <FormField fieldProps={{ name: "LastStockTaking", label: "Last Stock Taking", md: 5.8 }} formikProps={props}></FormField>
                                    <FormField fieldProps={{ name: "StockTakingInProgress", checkbox: true, label: "Stock Taking In Progress", md: 5.8 }} formikProps={props}>
                                    </FormField>
                                </FormContainerMolecule>
                            </ContentCard>
                            <ContentCard {...{ cardId: "Settings", md: 6 }}>
                                <FormContainerMolecule formikProps={props}>
                                    <FormField fieldProps={{ name: "IsPickupWarehouse", checkbox: true, label: "Is Pickup Warehouse", md: 5.8 }} formikProps={props}>
                                    </FormField>
                                    <FormField fieldProps={{ name: "IsStoreWarehouse", checkbox: true, label: "Is Store Warehouse", md: 5.8 }} formikProps={props}>
                                    </FormField>
                                    <FormField fieldProps={{ name: "IsActive", checkbox: true, label: "Is Active", md: 5.8 }} formikProps={props}>
                                    </FormField>
                                    <FormField fieldProps={{ name: "IsExternal", checkbox: true, label: "Is External", md: 5.8 }} formikProps={props}>
                                    </FormField>
                                    <FormField fieldProps={{ name: "CommInvoicePrinter[Name]", label: "Comm Invoice Printer", md: 5.8 }} formikProps={props}></FormField>
                                    <FormField fieldProps={{ name: "PickingListPrinter[Name]", label: "Picking List Printer", md: 5.8 }} formikProps={props}></FormField>
                                </FormContainerMolecule>
                            </ContentCard>

                        </ContentCardsContainer>




                        <ContentCardsContainer >
                            <ContentCard {...{
                                cardId: "TabContainer",
                                contentPadding: 0,
                                cardTypes: [CardType.tabContainer],
                                cardHeader: <HeaderTabs {...{ tabs, currentTab, setCurrentTab }} ></HeaderTabs>,
                                components: [
                                    //{ isInGroupedMenu: true, component: <ActionButton target='blank' variant='text' title="New Supplier Product" icon={<AddTwoToneIcon />} actionUrl={"/products/supplier-products/create?productId=" + editId} />},
                                ],
                            }}>
                                {/* 
                    {currentTab === "Products" &&
                        <ContentCard {...{ cardId: "Products", cardTypes: [CardType.tab], contentPadding: 0, }}>
                            <CustomDataGrid  columns={productsColumns} tableSettings={productsTableSettings}/>

                        </ContentCard>
                    } */}
                                {currentTab === "Product Locations" && warehouseId != null &&
                                    <ContentCard {...{ cardId: "Product Locations", cardTypes: [CardType.tab], contentPadding: 0 }}>
                                        <WarehouseProductLocations key={String(warehouseId)} warehouseId={warehouseId} />
                                    </ContentCard>
                                }
                                {currentTab === "Receiving Stations" &&
                                    <ContentCard {...{ cardId: "Receiving Stations", cardTypes: [CardType.tab], contentPadding: 0, }}>
                                        <CustomDataGrid columns={receivingstationColumns} tableSettings={receivingstationTableSettings} />

                                    </ContentCard>
                                }
                                {currentTab === "Packing Stations" &&
                                    <ContentCard {...{ cardId: "Packing Stations", cardTypes: [CardType.tab], contentPadding: 0, }}>

                                        <CustomDataGrid columns={packingstationColumns} tableSettings={packingstationTableSettings} />
                                    </ContentCard>
                                }
                                {currentTab === "Locations" &&
                                    <ContentCard {...{ cardId: "Locations", cardTypes: [CardType.tab], contentPadding: 0, }}>

                                        <CustomDataGrid columns={locationsColumns} tableSettings={locationsTableSettings} />
                                    </ContentCard>
                                }
                                {currentTab === "Dispatch Orders" &&
                                    <ContentCard {...{ cardId: "Dispatch Orders", cardTypes: [CardType.tab], contentPadding: 0, }}>
                                        <CustomDataGrid columns={dipatchOrderColumns} tableSettings={dispatchOrderTableSettings} getDetailPanelContent={(row) => <DisaptchOrderRowContent {...{ row }} />} />

                                    </ContentCard>
                                }
                                {currentTab === "Address" &&
                                    <ContentCard {...{ cardId: "Address", cardTypes: [CardType.tab] }}>
                                        <FormContainerMolecule formikProps={props}>
                                            <FormField fieldProps={{ name: "Address_Company", label: "Company", md: 5.8 }} formikProps={props}></FormField>
                                            <FormField fieldProps={{ name: "Address_Country_Value", label: "Country", md: 5.8 }} formikProps={props}>
                                            </FormField>
                                            <FormField fieldProps={{ name: "Address_Street", label: "Street", md: 3.8 }} formikProps={props}></FormField>
                                            <FormField fieldProps={{ name: "Address_StreetAdditionalInformation", label: "Street Additional Information", md: 3.8 }} formikProps={props}></FormField>
                                            <Grid item md={4}></Grid>
                                            <FormField fieldProps={{ name: "Address_Postcode", label: "Postcode", md: 3.8 }} formikProps={props}></FormField>
                                            <FormField fieldProps={{ name: "Address_City", label: "City", md: 3.8 }} formikProps={props}></FormField>
                                            <FormField fieldProps={{ name: "Address_County", label: "County", md: 3.8 }} formikProps={props}></FormField>
                                            <FormField fieldProps={{ name: "Address_State", label: "State", md: 3.8 }} formikProps={props}></FormField>
                                            <FormField fieldProps={{ name: "Address_Department", label: "Department", md: 3.8 }} formikProps={props}></FormField>
                                            <FormField fieldProps={{ name: "CorporateRegistrationNumber", label: "Corporate Registration Number", md: 3.8 }} formikProps={props}></FormField>
                                            <FormField fieldProps={{ name: "Address_EmailAddress", label: "Email Address", md: 12 }} formikProps={props}></FormField>
                                            <FormField fieldProps={{ name: "Address_AdditionalInformation", label: "Additional Information", md: 8.8 }} formikProps={props}></FormField>
                                            <FormField fieldProps={{ name: "Address_DoorCode", label: "Door Code", md: 1.8 }} formikProps={props}></FormField>
                                            <FormField fieldProps={{ name: "Address_MobileNumber", label: "Mobile", md: 12 }} formikProps={props}></FormField>
                                            <FormField fieldProps={{ name: "Address_FaxNumber", label: "Fax", md: 5.8 }} formikProps={props}></FormField>
                                            <FormField fieldProps={{ name: "Address_PhoneNumber", label: "Phone", md: 5.8 }} formikProps={props}></FormField>
                                        </FormContainerMolecule>


                                    </ContentCard>
                                }
                            </ContentCard>

                        </ContentCardsContainer>
                    </div>)}
            </Formik>

            <Footer />
        </>
    );
}

export default EditWarehouse;




const DisaptchOrderRowContent = ({ row }) => {
    const [columns, tableSettings] = useDispatchOrderRowsTable(row?.row?.DispatchOrderId);

    return (
        <DetailPanelContainer>
            <CustomDataGrid columns={columns} tableSettings={tableSettings} />
        </DetailPanelContainer>
    );
}

const WarehouseProductLocations = ({ warehouseId }: { warehouseId: string | number }) => {
    const [columns, tableSettings] = useWarehouseProductLocationsTable(warehouseId);
    return <CustomDataGrid columns={columns} tableSettings={tableSettings} />;
};
